/* unplugin-vue-components disabled */import script from "./authRole.vue?vue&type=script&setup=true&name=AuthRole&lang=js"
export * from "./authRole.vue?vue&type=script&setup=true&name=AuthRole&lang=js"

const __exports__ = script;

export default __exports__